import api from "./api";

const changeStatue = async function changeStatue(appNos, mode) {
  try {
    const params = {
      APP_NOS: appNos,
    };
    let url = '';
    switch (mode) {
      case 'ING':
        url = '/api/comp/recannJudgeIngStep';
        break;
      case 'PASS':
        url = '/api/comp/recannPass';
        break;
      case 'FAIL':
        url = '/api/comp/recannFail';
        break;
      default:
        throw new Error('유효하지 않은 심사상태입니다.');
    }
    const response = await api.post(url, null, { params });
    console.log('API 응답:', response.data);
    
    if (response.data.success === 'U') {
      return {
        success: true,
        message: response.data.message || response.data.msg || '심사상태가 성공적으로 변경되었습니다.',
      };
    }
    throw new Error('서버 응답 오류');
  } catch (error) {
    const errorMsg = new Error('심사상태 변경에 실패했습니다.');
    errorMsg.success = false;
    errorMsg.originalError = error;
    throw errorMsg;
  }
};

export { changeStatue };



// WEBPACK FOOTER //
// ./src/api/compAppRecann.js